module.exports = __webpack_public_path__ + "static/media/kitchen-19.26dfa618.jpg";